import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axiosInstance from "../api/axiosInstance";
import { useSelector } from "react-redux";
import socket from "../socket/socket";

const WalletContext = createContext();

const WalletProvider = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const [walletAmt, setwalletAmt] = useState(null);
  const [adminWallet, setAdminWalletAmt] = useState(null);
  const userId = userInfo?._id;
  const role = userInfo?.role;

  const refreshWalletCart = useCallback(
    async (id) => {
      const userIdToUse = id || userId;
      if (!userIdToUse) return;

      try {
        const response = await axiosInstance.get(`/api/wallet/${userIdToUse}`);
        const result = {
          success: true,
          data: response?.data?.data?.wallet,
          message: response?.data?.message || "Successful",
        };
        if (result?.success) {
          setwalletAmt(result.data);
          return result;
        }
      } catch (error) {
        return {
          success: false,
          message:
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Failed. Please try again.",
          status: error.response?.status || 500,
        };
      }
    },
    [userId]
  );

  const refreshadminWallet = useCallback(async () => {
    if (role !== "super_admin") return;

    try {
      const response = await axiosInstance.get(`/api/admin/bank/wallet`);
      const result = {
        success: true,
        data: response?.data?.data?.wallet,
        message: response?.data?.message || "Successful",
      };
      if (result?.success) {
        setAdminWalletAmt(result.data);
        return result;
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed. Please try again.",
        status: error.response?.status || 500,
      };
    }
  }, [role]);

  useEffect(() => {
    if (userId) refreshWalletCart(userId);
  }, [userId, refreshWalletCart]);

  useEffect(() => {
    if (role === "super_admin") refreshadminWallet();
  }, [role, refreshadminWallet]);

  useEffect(() => {
    const onWalletChanged = () => {
      refreshadminWallet();
      refreshWalletCart();
    };
    socket.on("wallet_changed", onWalletChanged);
    return () => socket.off("wallet_changed", onWalletChanged);
  }, [refreshWalletCart, refreshadminWallet]);

  return (
    <WalletContext.Provider
      value={{ walletAmt, refreshWalletCart, adminWallet, refreshadminWallet }}
    >
      {children}
    </WalletContext.Provider>
  );
};

const useWallet = () => useContext(WalletContext);

export { WalletProvider, useWallet };
